import { Component, Input, OnInit } from '@angular/core';
import { Fatura } from './../../../../../utils/fatura';
import { IFaturaLista } from '../../../../../interfaces/ifatura-lista';
import { IAgendaEduAccessInfo } from '../../../../../interfaces/iagenda-edu-access-info';
import { IResponsible } from './../../../../../interfaces/iresponsible';
import { IFatura } from './../../../../../interfaces/ifatura';
import { ResponsibleService } from './../../../../../services/responsible.service';
import { FaturaService } from './../../../../../services/fatura.service';
import { AccessInfo } from './../../../../../utils/access-info';

@Component({
  selector: 'eae-ficha-financeira',
  templateUrl: './eae-ficha-financeira.component.html',
  styles: [],
})
export class EaeFichaFinanceiraComponent implements OnInit {
  @Input()
  listaFaturas: IFaturaLista[] = [];

  constructor(
    private responsibleService: ResponsibleService,
    private faturaService: FaturaService
  ) {}

  ngOnInit(): void {
    const accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    const responsibleData: IResponsible =
      this.responsibleService.getResponsibleDataStored();
    this.getFaturas(accessInfo, responsibleData);
  }

  private loaded: boolean = false;

  public hasFaturas(): boolean {
    return Fatura.hasFaturas(this.listaFaturas);
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  async getFaturas(
    accessInfo: IAgendaEduAccessInfo,
    responsibleData: IResponsible
  ) {
    let faturas: IFatura[] = [];
    if (responsibleData) {
      if (!this.listaFaturas.length) {
        let studentServiceIds: string[] =
          responsibleData.financialResponsibleStudentServices.reduce(
            (acc: string[], val) => acc.concat(val.studentServiceIds),
            []
          );

        faturas = await this.faturaService.getFaturasByServiceIds(
          studentServiceIds,
          accessInfo.accessToken
        );

        this.faturaService.setFaturas(faturas);
      } else {
        faturas = this.faturaService.getFaturasStored();
      }

      this.listaFaturas = Fatura.prepareFaturasSortedAndAsFaturaLista(faturas);
    }
    this.loaded = true;
  }
}
